import NewButton from 'CMFW/button/NewButton';
import ReloadButton from 'CMFW/button/ReloadButton';
import ModuleContext from 'CMFW/context/ModuleContext';
import Grid from 'CMFW/grid/Grid';
import ItemLayout from 'CMFW/layout/ItemLayout';
import { LoadingItem } from 'CMFW/layout/Loading';
import { ContainerLeft, ContainerLeftFooter, ContainerRight, ModuleContainer } from 'components/common/styles';
import { Split } from 'components/Split';
import { useForceRender } from 'hooks/useForceRender';
import Note from 'modules/Note/Note';
import React, { useMemo, useState, useEffect, useCallback } from 'react';

import { ItemTabs } from '../../CMFW/layout/ItemTabs';
import TextSearch from '../../components/search/TextSearch';
import ReadingModel from '../../models/ReadingModel';
import ReadingEdit from './tabs/ReadingEdit';
import ReadingExercise from './tabs/ReadingExercise';
import ReadingText from './tabs/ReadingText';
import Button from '@material-ui/core/Button';
import { INavigationStep } from 'types/navigation';
import { IRefIds } from 'constants/refs';

export type IProps = {
  courseId: number;
  search?: string;
  navigationPath?: INavigationStep[];
};

const Reading: React.FC<IProps> = (props) => {
  const forceRender = useForceRender();
  const [showTabIndex, setShowTabIndex] = useState<number | undefined>();
  const [readingTextId, setReadingTextId] = useState<number>(0);
  const [readingExerciseId, setReadingExerciseId] = useState<number>(0);

  const readingModel = useMemo(
    () => new ReadingModel({ render: forceRender, courseId: props.courseId, search: props.search }),
    [forceRender, props.courseId, props.search],
  );

  // Process navigation path
  useEffect(() => {
    if (props.navigationPath && props.navigationPath.length > 0) {
      const firstStep = props.navigationPath[0];
      
      if (firstStep.ref === IRefIds.readingText) {
        setShowTabIndex(1); // Switch to Text tab
        setReadingTextId(firstStep.refId);
      } else if (firstStep.ref === IRefIds.readingExercise) {
        setShowTabIndex(2); // Switch to Exercises tab
        setReadingExerciseId(firstStep.refId);
      }
    }
  }, [props.navigationPath]);

  // Reset both IDs when clicking reading grid
  const resetChildIds = useCallback(() => {
    setReadingTextId(0);
    setReadingExerciseId(0);
  }, []);

  return (
    <ModuleContainer>
      <ModuleContext.Provider value={readingModel}>
        <Split widthLeft={500}>
          <ContainerLeft>
            <TextSearch />
            <Grid
              cellRenderers={{
              }}

              onRowClick={resetChildIds}
            />
            <ContainerLeftFooter>
              <ReloadButton />
              <Button variant="outlined" size="small" onClick={readingModel.checkReadings.bind(readingModel)}>
                check
              </Button>
              <NewButton />
            </ContainerLeftFooter>
          </ContainerLeft>
          <ContainerRight>
            <ItemLayout>
              <ItemTabs tabNames={['Edit', 'Text', 'Exercises']} showTabIndex={showTabIndex}>
                <ReadingEdit key={'Edit' + readingModel.itemId} />
                <ReadingText key={'Texts' + readingModel.itemId} readingTextId={readingTextId} />
                <ReadingExercise key={'Exercises' + readingModel.itemId} readingExerciseId={readingExerciseId} />
              </ItemTabs>
            </ItemLayout>
            <Note />
            <LoadingItem />
          </ContainerRight>
        </Split>
      </ModuleContext.Provider>
    </ModuleContainer>
  );
};

export default Reading;
